import script from "./ingrid-returns-modal.vue?vue&type=script&lang=js"
export * from "./ingrid-returns-modal.vue?vue&type=script&lang=js"

import "./ingrid-returns-modal.vue?vue&type=style&index=0&id=815a9c4e&lang=scss"

const __exports__ = script;

export default __exports__